module.exports = __webpack_public_path__ + "img/组 3.009d3077.webp";